import { svgCreate as o } from "./create-svg.js";
const c = o("XMark", "1.14.0"), t = o("WineGlass", "1.14.0"), e = o("WifiTV", "1.14.0"), s = o("Wifi", "1.14.0"), r = o("Wheelchair", "1.14.0"), i = o("WaterDrop", "1.14.0"), a = o("Wallet", "1.14.0"), I = o(
  "Utensils",
  "1.14.0"
), l = o("UploadCloud", "1.14.0"), C = o("Upload", "1.14.0"), u = o("TrayTable", "1.14.0"), d = o("Trash", "1.14.0"), S = o(
  "TransportationMode",
  "1.14.0"
), g = o("Toilet", "1.14.0"), p = o("Tickets", "1.14.0"), b = o("Thumbs", "1.14.0"), h = o("Table", "1.14.0"), k = o("TV", "1.14.0"), w = o("Sunrise", "1.14.0"), A = o("Sun", "1.14.0"), M = o("Stars", "1.14.0"), m = o("Star", "1.14.0"), T = o("Spinner", "1.14.0"), B = o("Sort", "1.14.0"), D = o("Social", "1.14.0"), P = o(
  "Snowflake",
  "1.14.0"
), y = o("Silence", "1.14.0"), f = o("SignPost", "1.14.0"), L = o("SignOut", "1.14.0"), R = o("ShinyBubbles", "1.14.0"), W = o("Shield", "1.14.0"), v = o("Share", "1.14.0"), E = o("SecurityCamera", "1.14.0"), x = o(
  "SeatedPassenger",
  "1.14.0"
), F = o("SeatSize", "1.14.0"), H = o("SeatBelt", "1.14.0"), G = o("Ribbon", "1.14.0"), z = o("Review", "1.14.0"), U = o("ReservedSeat", "1.14.0"), V = o("Report", "1.14.0"), O = o("Refund", "1.14.0"), Q = o("Rabbit", "1.14.0"), K = o("QuestionMarkCircle", "1.14.0"), N = o("QrCode", "1.14.0"), X = o(
  "PowerOutlet",
  "1.14.0"
), j = o("Plus", "1.14.0"), q = o("PinDrop", "1.14.0"), J = o("Person", "1.14.0"), Y = o("Pencil", "1.14.0"), Z = o("Paw", "1.14.0"), _ = o("Paperclip", "1.14.0"), $ = o("PanoramicView", "1.14.0"), oo = o("NoFees", "1.14.0"), no = o("Moon", "1.14.0"), co = o("Minus", "1.14.0"), to = o("Minimize", "1.14.0"), eo = o("MeetingTable", "1.14.0"), so = o("Maximize", "1.14.0"), ro = o("Marker", "1.14.0"), io = o("Map", "1.14.0"), ao = o("MagnifyingGlass", "1.14.0"), Io = o("Luggage", "1.14.0"), lo = o(
  "LongArrow",
  "1.14.0"
), Co = o("Lock", "1.14.0"), uo = o("Location", "1.14.0"), So = o("Leaf", "1.14.0"), go = o("InfoCircle", "1.14.0"), po = o("Inbox", "1.14.0"), bo = o("ID", "1.14.0"), ho = o("House", "1.14.0"), ko = o(
  "HotDrink",
  "1.14.0"
), wo = o("Heating", "1.14.0"), Ao = o("Heart", "1.14.0"), Mo = o("HamburgerMenu", "1.14.0"), mo = o("Globe", "1.14.0"), To = o("Gender", "1.14.0"), Bo = o("Flag", "1.14.0"), Do = o("Filters", "1.14.0"), Po = o("Film", "1.14.0"), yo = o("FerrisWheel", "1.14.0"), fo = o("Eye", "1.14.0"), Lo = o("ExternalLink", "1.14.0"), Ro = o(
  "ExclamationMarkCircle",
  "1.14.0"
), Wo = o("Envelope", "1.14.0"), vo = o(
  "Ellipsis",
  "1.14.0"
), Eo = o("Download", "1.14.0"), xo = o("Discount", "1.14.0"), Fo = o("Diamond", "1.14.0"), Ho = o(
  "CurvedArrow",
  "1.14.0"
), Go = o(
  "Currency",
  "1.14.0"
), zo = o("CreditCard", "1.14.0"), Uo = o("Cog", "1.14.0"), Vo = o("Clock", "1.14.0"), Oo = o("City", "1.14.0"), Qo = o("Chevron", "1.14.0"), Ko = o(
  "Checkpoint",
  "1.14.0"
), No = o(
  "CheckCircle",
  "1.14.0"
), Xo = o("Check", "1.14.0"), jo = o("ChartArea", "1.14.0"), qo = o("Caret", "1.14.0"), Jo = o("Camera", "1.14.0"), Yo = o(
  "CalendarDate",
  "1.14.0"
), Zo = o("Calendar", "1.14.0"), _o = o("BusbudCoin", "1.14.0"), $o = o("Busbud", "1.14.0"), on = o("Bug", "1.14.0"), nn = o("Box", "1.14.0"), cn = o("Bolt", "1.14.0"), tn = o("Bicycle", "1.14.0"), en = o("Ban", "1.14.0"), sn = o("Bag", "1.14.0"), rn = o("Attendant", "1.14.0"), an = o("ArrowTopDown", "1.14.0"), In = o("ArrowLeftRight", "1.14.0"), ln = o(
  "ArrowBiDirectional",
  "1.14.0"
), Cn = o("Arrow", "1.14.0"), un = o("Armchair", "1.14.0"), dn = o("Apple", "1.14.0"), Sn = o("AidKit", "1.14.0"), gn = o("Activity", "1.14.0"), pn = o("AED", "1.14.0");
export {
  pn as IconAED,
  gn as IconActivity,
  Sn as IconAidKit,
  dn as IconApple,
  un as IconArmchair,
  Cn as IconArrow,
  ln as IconArrowBiDirectional,
  In as IconArrowLeftRight,
  an as IconArrowTopDown,
  rn as IconAttendant,
  sn as IconBag,
  en as IconBan,
  tn as IconBicycle,
  cn as IconBolt,
  nn as IconBox,
  on as IconBug,
  $o as IconBusbud,
  _o as IconBusbudCoin,
  Zo as IconCalendar,
  Yo as IconCalendarDate,
  Jo as IconCamera,
  qo as IconCaret,
  jo as IconChartArea,
  Xo as IconCheck,
  No as IconCheckCircle,
  Ko as IconCheckpoint,
  Qo as IconChevron,
  Oo as IconCity,
  Vo as IconClock,
  Uo as IconCog,
  zo as IconCreditCard,
  Go as IconCurrency,
  Ho as IconCurvedArrow,
  Fo as IconDiamond,
  xo as IconDiscount,
  Eo as IconDownload,
  vo as IconEllipsis,
  Wo as IconEnvelope,
  Ro as IconExclamationMarkCircle,
  Lo as IconExternalLink,
  fo as IconEye,
  yo as IconFerrisWheel,
  Po as IconFilm,
  Do as IconFilters,
  Bo as IconFlag,
  To as IconGender,
  mo as IconGlobe,
  Mo as IconHamburgerMenu,
  Ao as IconHeart,
  wo as IconHeating,
  ko as IconHotDrink,
  ho as IconHouse,
  bo as IconID,
  po as IconInbox,
  go as IconInfoCircle,
  So as IconLeaf,
  uo as IconLocation,
  Co as IconLock,
  lo as IconLongArrow,
  Io as IconLuggage,
  ao as IconMagnifyingGlass,
  io as IconMap,
  ro as IconMarker,
  so as IconMaximize,
  eo as IconMeetingTable,
  to as IconMinimize,
  co as IconMinus,
  no as IconMoon,
  oo as IconNoFees,
  $ as IconPanoramicView,
  _ as IconPaperclip,
  Z as IconPaw,
  Y as IconPencil,
  J as IconPerson,
  q as IconPinDrop,
  j as IconPlus,
  X as IconPowerOutlet,
  N as IconQrCode,
  K as IconQuestionMarkCircle,
  Q as IconRabbit,
  O as IconRefund,
  V as IconReport,
  U as IconReservedSeat,
  z as IconReview,
  G as IconRibbon,
  H as IconSeatBelt,
  F as IconSeatSize,
  x as IconSeatedPassenger,
  E as IconSecurityCamera,
  v as IconShare,
  W as IconShield,
  R as IconShinyBubbles,
  L as IconSignOut,
  f as IconSignPost,
  y as IconSilence,
  P as IconSnowflake,
  D as IconSocial,
  B as IconSort,
  T as IconSpinner,
  m as IconStar,
  M as IconStars,
  A as IconSun,
  w as IconSunrise,
  k as IconTV,
  h as IconTable,
  b as IconThumbs,
  p as IconTickets,
  g as IconToilet,
  S as IconTransportationMode,
  d as IconTrash,
  u as IconTrayTable,
  C as IconUpload,
  l as IconUploadCloud,
  I as IconUtensils,
  a as IconWallet,
  i as IconWaterDrop,
  r as IconWheelchair,
  s as IconWifi,
  e as IconWifiTV,
  t as IconWineGlass,
  c as IconXMark
};
